import { render, staticRenderFns } from "./CategoryDemand.vue?vue&type=template&id=c2362f40&scoped=true"
import script from "./CategoryDemand.vue?vue&type=script&lang=js"
export * from "./CategoryDemand.vue?vue&type=script&lang=js"
import style0 from "./CategoryDemand.vue?vue&type=style&index=0&id=c2362f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2362f40",
  null
  
)

export default component.exports